/** Human-readable labels for diagnostic answer keys/values (download + display). */

export const BUSINESS_TYPE_LABELS = {
  medspa: 'Medspa / cosmetic clinic',
  insurance: 'Insurance broker',
  mortgage: 'Mortgage broker',
  vet: 'Veterinary clinic',
  law: 'Law firm',
  accounting: 'Accounting firm',
  gym: 'Gym / fitness studio',
  realestate: 'Real estate team',
  dealership: 'Auto dealership',
  trades: 'Trades: HVAC, plumbing, electrical',
  medical: 'Medical practice',
};

const TEAM_SIZE_LABELS = {
  solo: 'Solo / micro (1–3 people)',
  small: 'Small team (4–10)',
  medium: 'Growing (11–30)',
  large: 'Larger org (31+)',
};

const INQUIRY_LABELS = {
  fast: 'Someone responds within the hour',
  sameday: 'Usually same day, a few hours',
  slow: 'Could be next day or later',
  slips: 'Some slip through the cracks',
};

const AFTER_HOURS_LABELS = {
  handled: 'We have something in place for it',
  voicemail: 'Voicemail or a generic auto-reply',
  miss: 'Most don\'t hear from us until we notice',
  nothing: 'Nothing — they wait until we open',
};

const FOLLOW_UP_LABELS = {
  auto: 'Automated follow-up goes out',
  manual: 'Someone on the team reaches out',
  sometimes: 'We try, but it\'s inconsistent',
  never: 'We move on — nothing goes out',
};

const MONTHLY_INQUIRY_LABELS = {
  low: 'Under 10',
  mid: '10–30',
  high: '30–60',
  vhigh: '60+',
};

const FIELD_LABELS = {
  business_type: 'Business type',
  team_size: 'Team size',
  inquiry_handling: 'New inquiry handling',
  after_hours: 'After-hours outreach',
  follow_up: 'Follow-up when interest doesn\'t convert',
  monthly_inquiries: 'Monthly new inquiries (approx.)',
};

const VALUE_LABELS = {
  team_size: TEAM_SIZE_LABELS,
  inquiry_handling: INQUIRY_LABELS,
  after_hours: AFTER_HOURS_LABELS,
  follow_up: FOLLOW_UP_LABELS,
  monthly_inquiries: MONTHLY_INQUIRY_LABELS,
};

/**
 * @param {Record<string, string>} answers
 * @returns {string[]} lines for plain-text export
 */
export function formatAnswersHumanLines(answers) {
  if (!answers || typeof answers !== 'object') return [];
  const order = [
    'business_type',
    'team_size',
    'inquiry_handling',
    'after_hours',
    'follow_up',
    'monthly_inquiries',
  ];
  const lines = [];
  for (const key of order) {
    if (answers[key] == null || answers[key] === '') continue;
    const fieldName = FIELD_LABELS[key] || key;
    let display;
    if (key === 'business_type') {
      display = BUSINESS_TYPE_LABELS[answers[key]] || answers[key];
    } else {
      const map = VALUE_LABELS[key];
      display = map?.[answers[key]] || answers[key];
    }
    lines.push(`- ${fieldName}: ${display}`);
  }
  return lines;
}
